const MetaFieldInitialValuesMap = {
  COMMON: {
    field_name: "",
    description: "",
  },
  CHECKBOX: {
    options: [""],
    default: [false],
  },
  SINGLE_SELECT: {
    options: ["", ""],
    default: [false, false],
  },
  NUMBER: {
    default: "",
  },
  SINGLE_LINE_TEXT: {
    default: "",
  },
  DATE: {
    format: "",
  },
};

const MetaFieldComponentRules = {
  COMMON: {
    field_name: {
      required: ({ value }) => value.trim("").length > 0,
    },
    description: {
      required: ({ value }) => value.trim("").length > 0,
      // minLength: ({ value }) => value.trim("").length > 5,
    },
  },
  SINGLE_SELECT: {
    options: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  CHECKBOX: {
    options: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  NUMBER: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  DATE: {
    format: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  SINGLE_LINE_TEXT: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
};

const MetaFieldComponentMessages = {
  COMMON: {
    field_name: {
      required: "Field name is a mandatory field",
    },
    description: {
      required: "Field description is a mandatory field",
      minLength: "Field description should have a minimum length of 5",
    },
  },
  SINGLE_SELECT: {
    options: [""],
    default: [false],
  },
  CHECKBOX: {
    options: {
      required: "Please enter a default value",
    },
  },
  NUMBER: {
    default: {
      required: "Please enter number",
    },
  },
  SINGLE_LINE_TEXT: {
    default: {
      required: "Please enter value",
    },
  },
  DATE: {
    format: {
      required: "Please select format",
    },
  },
};

const TransformMetaFieldValue = {
  NUMBER: {
    default: ({ value }) => parseInt(value, 10),
  },
  RATE: {
    rateValue: ({ value }) => parseInt(value, 10),
  },
  PERIOD: {
    periodValue: ({ value }) => parseInt(value, 10),
  },
};

export {
  MetaFieldInitialValuesMap,
  MetaFieldComponentMessages,
  MetaFieldComponentRules,
  TransformMetaFieldValue,
};
